import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import styles from "./App.module.css";
import { trackEvent } from "./analytics";

const APP_STORE_URL = "https://apps.apple.com/us/app/creataai/id1659088194";

const Create = () => {
  const theme = createTheme({ palette: { mode: "dark" } });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <main className={styles.landingPage}>
        <nav className={styles.marketingNav} aria-label="Main navigation">
          <a className={styles.navBrand} href="/" aria-label="Creata AI home">
            <img src="/img/creataai_logo_white.png" width="42" height="35" alt="" />
            <span>Creata AI</span>
          </a>
          <a className={styles.routeBack} href="/">Back to home</a>
        </nav>

        <section className={styles.downloadRoute} aria-labelledby="download-route-title">
          <div>
            <p className={styles.eyebrow}>Creata AI for iPhone</p>
            <h1 id="download-route-title">Take the creative studio with you.</h1>
            <p>
              Say what you want, paste a link, or share a page, then listen, summarize, create art, edit a photo, or make an MP3, podcast, or song. Start with free credits.
            </p>
            <a
              className={styles.primaryCta}
              href={APP_STORE_URL}
              target="_blank"
              rel="noreferrer"
              onClick={() => trackEvent("app_store_click", { app_name: "Creata AI", placement: "create_route" })}
            >
              Download on the App Store <ArrowForwardIcon fontSize="small" />
            </a>
            <div className={styles.routeHighlights}>
              <span>Chat-first home</span>
              <span>Listen + summarize</span>
              <span>Art, photo edits + audio</span>
            </div>
          </div>
          <figure className={styles.routeScreen}>
            <img src="/img/app-screens/chat-home.png" alt="Creata AI chat home" />
          </figure>
        </section>
      </main>
    </ThemeProvider>
  );
};

export default Create;
